import * as React from 'react'
import * as Highcharts from 'highcharts'
import moment from 'moment'

const defaultMin = moment().startOf('month').format('YYYY-MM-DD hh:mm')
const defaultMax = moment().endOf('month').format('YYYY-MM-DD hh:mm')

const barLineChartsdefaultOptions = {
  title: {
    text: '',
  },
  chart: {
    zoomType: 'x',
    style: {
      fontFamily: 'TelstraAkkurat-Regular',
    },
  },
  credits: {
    enabled: false,
  },
  xAxis: {
    type: 'datetime',
    min: Date.parse(defaultMin),
    max: Date.parse(defaultMax),
    plotLines: [],
    tickInterval: 4 * 24 * 3600 * 1000,
    tickPositioner: (min, max) => {
      const interval = barLineChartsdefaultOptions.xAxis.tickInterval
      const ticks = []
      let count = 0

      while (min < max) {
        ticks.push(min)
        min += interval
        count++
      }

      // eslint-disable-next-line dot-notation,@typescript-eslint/dot-notation
      ticks['info'] = {
        unitName: 'day',
        count: 5,
        higherRanks: {},
        totalRange: interval * count,
      }

      return ticks
    },
  },
  yAxis: {
    labels: {
      format: '{value} MB',
      formatter: null,
      style: {
        color: '#767676',
        fontFamily: 'AkkuratPro-Regular vHelvetica Neue, Helvetica, Arial, sans-serif',
        fontWeight: 'normal',
        fontSize: '12px',
      },
    },
    title: {
      text: '',
    },
    gridLineDashStyle: 'longdash',
    min: 0,
    max: 800,
    tickInterval: 200,
  },
  legend: {
    symbolRadius: 0,
    symbolWidth: 10,
  },
  plotOptions: {
    series: {
      pointWidth: 20,
      marker: {
        enabled: false,
      },
    },
    column: {
      stacking: 'normal',
      dataLabels: {
        enabled: false,
      },
    },
  },
  series: [
    {
      name: 'Past Usage',
      type: 'column',
      data: [],
      legendIndex: 0,
      color: '#D8D8D8',
      tooltip: {
        xDateFormat: '%A %d %B %Y',
        valueSuffix: ' MB',
      },
    },
    {
      name: 'Active day pass',
      type: 'column',
      data: [],
      index: 1,
      legendIndex: 1,
      color: '#008A00',
      tooltip: {
        xDateFormat: '%A %d %B %Y',
        valueSuffix: ' MB',
      },
    },
    {
      name: 'Active data top-up',
      type: 'column',
      data: [],
      index: 0,
      legendIndex: 2,
      color: '#F05A00',
      tooltip: {
        xDateFormat: '%A %d %B %Y',
        valueSuffix: ' MB',
      },
    },
    {
      name: 'Pay as you go',
      type: 'line',
      data: [],
      legendIndex: 3,
      color: '#D0021B',
      tooltip: {
        xDateFormat: '%A %d %B %Y',
        valueSuffix: ' MB',
      },
    },
  ],
  responsive: {
    rules: [
      {
        chartOptions: {
          legend: {
            padding: 3,
            itemMarginTop: 5,
            itemMarginBottom: 5,
          },
          plotOptions: {
            series: {
              pointWidth: 7,
            },
          },
        },
        condition: {
          maxWidth: 500,
        },
      },
    ],
  },
}

export const DefaultInternationalUsageBarLineChart = () => {
  React.useEffect(() => {
    const chartOptions: unknown = barLineChartsdefaultOptions
    const chart = Highcharts.chart('np-bar-line-chart-picker', chartOptions)
    return () => chart.destroy()
  }, [])

  return (
    <div className="np-bar-line-chart-container">
      <div id="np-bar-line-chart-picker" />
    </div>
  )
}
